<div class="content-block">
  <article class="article " style="margin-top:1rem">

    <div class="back-container borderless">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>
    </div>
    <div class="form-column borderless">

      <div class="form-groups-row buffer-bottom">
        <div class="form-group" style="width: 100%;">
          <label>Location *</label>
          <app-location-picker [locationId]="equip.location_Id" [companyId]="equip.company_Id"
            (onLocationSet)="onLocationChange($event)"></app-location-picker>
        </div>

          <div class="form-group" style="width: 100%;">
          <div style="display: flex;flex-direction: row;">
            <div style="width:100%;">
              <app-sublocation-picker [triggerUpdate]="triggerSubLocationUpdate"
                [sublocationId]="equip.sublocationId" [locationId]="equip.location_Id"
                (onSublocationSet)="onSublocationChange($event)"
                [_placeholder]="'Optional'"></app-sublocation-picker>
            </div>
            <button class="btn btn-primary" (click)="addSublocation()">+</button>
          </div>
        </div>

      </div>
      <div class="form-groups-row buffer-bottom">
        
        <div class="form-group" style="width: 100%;">
          <label>Category *</label>
          <app-category-picker [categoryId]="equip.category_Id" [_placeholder]="'Please Select'"
            (onCategorySet)="onCategoryChange($event)"></app-category-picker>

        </div>


        <div class="form-group" style="width: 100%;">
          <label>Manufacturer</label>
          <app-manufacturer-picker [manufacturerId]="equip.manufacturer_Id" [_placeholder]="'Optional'"
            (onManufacturerSet)="onManufacturerChange($event)"></app-manufacturer-picker>

        </div>

      </div>

      <div class="form-groups-row buffer-bottom">
                <div class="form-group" style="width: 100%;">
          <label>Description *</label>
          <input type="text" [(ngModel)]="equip.description" />
        </div>

        <div class="form-group" style="width: 100%;">
          <label>Serial # *</label>
          <label class="small" *ngIf="this.equip.id == null" style="font-size:12;font-style:italic">Create Multiple items by seperating the serial numbers with a comma (,)</label>

          <input type="text" [(ngModel)]="equip.serial_Num" />
        </div>
       

      </div>
      <div class="form-groups-row buffer-bottom">
         <div class="form-group" style="width: 100%;">
          <label>Asset #</label>
          <input type="text" [(ngModel)]="equip.asset_Num" />
        </div>
        <div class="form-group" style="width: 100%;">
          <label>SWL *</label>
          <input type="text" [(ngModel)]="equip.swl" />
        </div>

      </div>
      <div class="form-groups-row buffer-bottom">
        
        <div class="form-group" style="width: 100%;">
          <label>Job Number</label>
          <input type="text" [(ngModel)]="equip.doc" />
        </div>
        <div class="form-group" style="width: 100%;">
          <label>Other Details</label>
          <input type="text" [(ngModel)]="equip.other_Details" />
          </div>
          
          </div>
          <!-- PPE -->
          <div class="form-groups-row buffer-bottom" *ngIf="equip.reportType == 1" >
          
            <div class="form-group" style="width: 100%;">
              <label>Date of First Use</label>
              <div style="display: flex;flex-direction: row;align-content: center;align-items: center;justify-content: space-around;">
          
                <input type="text" [(ngModel)]="equip.date_Of_First_Use" />
                <i class="fa fa-calendar primary"
                  style="font-size: 2em;margin-left: 0.25rem;margin-bottom: 0.25rem;"
                  aria-hidden="true" (click)="openCalendar($event)"></i>
                <p-calendar name="date_Of_First_Use_Calendar" firstDayOfWeek="1" #date_Of_First_Use_Calendar
                  [style]="{'width':'100%', 'border-color':'#ccc', 'margin-left': '0.5rem'}" [hidden]="true" appendTo="body"
                  (onSelect)="onCalendarChange()" [inputStyle]="{'width':'100%', 'border-color':'#ccc'}"
                  [(ngModel)]="equip.date_Of_First_Use_Date" panelStyleClass="modal-calendar" dateFormat="dd/mm/yy"></p-calendar>
              </div>
            </div>
            <div class="form-group" style="width: 100%;">
          
            </div>
          </div>
          </div>


    <div class="btn-container">
      <button *ngIf="this.equip.id != null &&  equip.expired" class="btn btn-secondary" (click)="delete()">Reactivate</button>
      <button *ngIf="this.equip.id != null && !equip.expired" class="btn btn-secondary" (click)="delete()">Deactivate</button>
      <div class="spacer" *ngIf="id == null"></div>
      <button class="btn btn-primary" (click)="save()">Save</button>

    </div>

  </article>

</div>


<popup-modal id="popup-sublocation-add">
  <article class="popup-artical">
    <div class="popup-container">
      <div class="popup-header">
        <h2>Add new Sublocation</h2>
      </div>

      <div class="popup-content">
        <div class="input-column">
          <table>
            <tr>
              <td><label>Name</label></td>
              <td> <input type="text" [(ngModel)]="subLocationName" /></td>
            </tr>
          </table>
        </div>

        <div class="popup-footer">
          <div class="btn-container">
            <button class="btn btn-secondary" (click)="cancelModal('popup-sublocation-add')">Cancel</button>
            <button class="btn btn-primary" (click)="saveSubLocation()">Save</button>

          </div>
        </div>
      </div>
    </div>
  </article>

</popup-modal>